import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Alert, AlertDescription } from '../ui/alert';
import {
  Lock, Loader2, CheckCircle2, AlertCircle,
  Eye, EyeOff, Shield
} from 'lucide-react';

export const ConfigSenha = ({
  formData,
  loading,
  success,
  error,
  showSenhaAtual,
  setShowSenhaAtual,
  showNovaSenha,
  setShowNovaSenha,
  showConfirmarSenha,
  setShowConfirmarSenha,
  handleChange,
  handleSubmit,
  handleCancel
}) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Shield className="h-5 w-5" />
        Alterar Senha
      </CardTitle>
      <CardDescription>
        Atualize sua senha de acesso ao sistema
      </CardDescription>
    </CardHeader>
    <CardContent>
      <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
        {error && (
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        {success && (
          <Alert className="bg-green-50 text-green-800 border-green-200">
            <CheckCircle2 className="h-4 w-4" />
            <AlertDescription>Senha alterada com sucesso!</AlertDescription>
          </Alert>
        )}

        {/* Current Password */}
        <div className="space-y-2">
          <Label htmlFor="senhaAtual">Senha atual</Label>
          <div className="relative">
            <Input
              id="senhaAtual"
              type={showSenhaAtual ? "text" : "password"}
              placeholder="Digite sua senha atual"
              value={formData.senhaAtual}
              onChange={(e) => handleChange('senhaAtual', e.target.value)}
              required
              className="pr-10"
              data-testid="input-senha-atual"
            />
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="absolute right-0 top-0 h-full px-3 hover:bg-transparent"
              onClick={() => setShowSenhaAtual(!showSenhaAtual)}
            >
              {showSenhaAtual ? (
                <EyeOff className="h-4 w-4 text-muted-foreground" />
              ) : (
                <Eye className="h-4 w-4 text-muted-foreground" />
              )}
            </Button>
          </div>
        </div>

        {/* New Password */}
        <div className="space-y-2">
          <Label htmlFor="novaSenha">Nova senha</Label>
          <div className="relative">
            <Input
              id="novaSenha"
              type={showNovaSenha ? "text" : "password"}
              placeholder="Mínimo 10 caracteres"
              value={formData.novaSenha}
              onChange={(e) => handleChange('novaSenha', e.target.value)}
              required
              className="pr-10"
              data-testid="input-nova-senha"
            />
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="absolute right-0 top-0 h-full px-3 hover:bg-transparent"
              onClick={() => setShowNovaSenha(!showNovaSenha)}
            >
              {showNovaSenha ? (
                <EyeOff className="h-4 w-4 text-muted-foreground" />
              ) : (
                <Eye className="h-4 w-4 text-muted-foreground" />
              )}
            </Button>
          </div>
          {formData.novaSenha && formData.novaSenha.length < 10 && (
            <p className="text-xs text-red-500">Mínimo de 10 caracteres ({10 - formData.novaSenha.length} restantes)</p>
          )}
          {formData.novaSenha.length >= 10 && (
            <p className="text-xs text-green-500 flex items-center gap-1">
              <CheckCircle2 className="h-3 w-3" /> Tamanho mínimo atingido
            </p>
          )}
        </div>

        {/* Confirm New Password */}
        <div className="space-y-2">
          <Label htmlFor="confirmarSenha">Confirmar nova senha</Label>
          <div className="relative">
            <Input
              id="confirmarSenha"
              type={showConfirmarSenha ? "text" : "password"}
              placeholder="Repita a nova senha"
              value={formData.confirmarSenha}
              onChange={(e) => handleChange('confirmarSenha', e.target.value)}
              required
              className="pr-10"
              data-testid="input-confirmar-senha"
            />
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="absolute right-0 top-0 h-full px-3 hover:bg-transparent"
              onClick={() => setShowConfirmarSenha(!showConfirmarSenha)}
            >
              {showConfirmarSenha ? (
                <EyeOff className="h-4 w-4 text-muted-foreground" />
              ) : (
                <Eye className="h-4 w-4 text-muted-foreground" />
              )}
            </Button>
          </div>
          {formData.confirmarSenha && formData.novaSenha !== formData.confirmarSenha && (
            <p className="text-xs text-red-500">Nova senha e confirmação não conferem.</p>
          )}
          {formData.confirmarSenha && formData.novaSenha === formData.confirmarSenha && formData.novaSenha.length >= 10 && (
            <p className="text-xs text-green-500 flex items-center gap-1">
              <CheckCircle2 className="h-3 w-3" /> Senhas conferem
            </p>
          )}
        </div>

        <div className="flex gap-3 pt-2">
          <Button 
            type="button" 
            variant="outline"
            onClick={handleCancel}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button 
            type="submit" 
            disabled={loading || formData.novaSenha.length < 10 || formData.novaSenha !== formData.confirmarSenha}
            data-testid="btn-salvar-senha"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Salvando...
              </>
            ) : (
              <>
                <Lock className="h-4 w-4 mr-2" />
                Salvar
              </>
            )}
          </Button>
        </div>
      </form>
    </CardContent>
  </Card>
);
